import { render, staticRenderFns } from "./LecturesListFilters.vue?vue&type=template&id=0e0c7bd5&"
import script from "./LecturesListFilters.vue?vue&type=script&lang=js&"
export * from "./LecturesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./LecturesListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports